import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { useLayoutEffect } from '@snack-uikit/utils';
import { getMatchMedia, MEDIA_QUERY_LIST } from '../utils';
export var useMatchMedia = function useMatchMedia() {
  var _useState = useState(getMatchMedia),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  useLayoutEffect(function () {
    var handler = function handler() {
      return setValue(getMatchMedia);
    };
    MEDIA_QUERY_LIST.forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        mql = _ref2[1];
      return mql.addEventListener('change', handler);
    });
    return function () {
      return MEDIA_QUERY_LIST.forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          mql = _ref4[1];
        return mql.removeEventListener('change', handler);
      });
    };
  }, []);
  return value;
};